import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: block;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
